import React, {Component} from 'react'
import {Typeahead} from 'react-bootstrap-typeahead-ali/dist/react-bootstrap-typeahead'
import {Media, Row, Image} from 'react-bootstrap'
import {Actions} from 'jumpstate'

const horseAvatar = `${window.location.protocol}//${window.location.host}/horse.jpg`

class HorseSeeker extends Component {
  constructor (props) {
    super(props)
    this.state = {
      term: '',
      options: [],
      message: '',
      horse: {
        id: props.valueObject.id || null,
        name: props.valueObject.name || '',
        avatar: props.valueObject.avatar || null,
        strain: props.valueObject.strain || null
      }
    }
    this.timeout = null
    this.seek = this.seek.bind(this)
    this.pickOption = this.pickOption.bind(this)
    this.changeKeyword = this.changeKeyword.bind(this)
  }

  seek (keyword) {
    const {gender} = this.props
    Actions.horseSeek({gender, keyword}).then((res) => {
      if (res.data.length === 0) {
        this.setState({options: [], message: 'موردی یافت نشد'})
      } else {
        this.setState({options: res.data, message: ''})
      }
    })
  }

  pickOption (picked) {
    if (picked.length === 0) { return undefined }
    this.setState({horse: picked[0]})
    const parent = {}
    parent[this.props.gender] = picked[0]
    parent[`${this.props.gender}_id`] = picked[0].id
    Actions.setNewHorseDetails(parent)
    if (this.props.gender === 'dam') {
      Actions.setNewHorseDetails({strain: picked[0].strain})
    }
  }

  changeKeyword (keyword) {
    this.setState({message: keyword, term: keyword})
    Actions.addNewHorseTouched(this.props.name)
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (keyword.length > 0) {
      this.timeout = setTimeout(() => {
        Actions.horseSeek({keyword, gender: this.props.gender}).then((res) => {
          if (res.data.length === 0) {
            this.setState({options: [], message: 'موردی یافت نشد'})
          } else {
            this.setState({options: res.data, message: ''})
          }
        })
      }, 700)
    } else {
      this.setState({message: '', options: []})
    }
  }

  render () {
    const {options, message, horse} = this.state
    const {placeholder, errors, name} = this.props

    return (
      <Row>
        <Image src={horse.avatar ? horse.avatar : horseAvatar} className="Avatar" />
        <Typeahead
          onChange={this.pickOption}
          onInputChange={this.changeKeyword}
          emptyLabel={message}
          placeholder={placeholder}
          className={`Name blink ${errors && 'has-error'}`}
          labelKey="name"
          options={options}
          defaultText={horse.name}
          onBlur={() => { Actions.addNewHorseTouched(name); Actions.validateNewHorseData() }}

          renderMenuItemChildren={(option) => {
            return [
              <Media key={option.id}>
                <Media.Left>
                  <Image width={32} height={32} src={option.avatar ? option.avatar : horseAvatar} />
                </Media.Left>
                <Media.Body>
                  <Media.Heading>{option.name}</Media.Heading>
                  <p>{option.strain}</p>
                </Media.Body>
              </Media>
            ]
          }}
        />
        <h6 className="Strain">{horse.strain ? horse.strain : 'تیره'}</h6>
      </Row>
    )
  }
}

HorseSeeker.propTypes = {
  gender: React.PropTypes.string.isRequired,
  name: React.PropTypes.string,
  errors: React.PropTypes.string,
  valueObject: React.PropTypes.object
}

export default HorseSeeker



// WEBPACK FOOTER //
// ./src/components/NewHorse/HorseSeeker/HorseSeeker.js